(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-cgg-collection]').forEach(section => {
      if (section.dataset.cggReady) return;
      section.dataset.cggReady = 'true';
      const current = new URL(window.location.href);
      const previewTheme = window.Shopify?.theme;
      if (['unpublished', 'development', 'demo'].includes(previewTheme?.role) && previewTheme.id && !window.Shopify?.designMode) {
        current.searchParams.set('preview_theme_id', previewTheme.id);
        document.querySelectorAll('a[href]').forEach(link => {
          const url = new URL(link.href, current);
          if (url.origin !== current.origin || !url.pathname.includes('/collections/') || url.pathname.includes('/products/')) return;
          url.searchParams.set('preview_theme_id', previewTheme.id);
          link.href = url.href;
        });
      }
      // Never redirect a plain collection URL: robots.txt blocks every sort_by URL, so Google reports the
      // collection as blocked. Featured order comes from the collection's admin sort setting instead.
      if (['title-ascending', 'title-descending', 'most-relevant'].includes(current.searchParams.get('sort_by')) && !window.Shopify?.designMode) {
        current.searchParams.set('sort_by', 'manual');
        current.searchParams.delete('page');
        window.location.replace(current.href);
        return;
      }
      const retained = [...current.searchParams].filter(([key]) =>
        key === 'view' || key === 'preview_theme_id' || key.startsWith('utm_') || ['gclid', 'fbclid'].includes(key));
      section.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, current);
        if (url.origin !== current.origin || !url.pathname.includes('/collections/')) return;
        retained.forEach(([key, value]) => {
          if (key === 'preview_theme_id' || !url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        link.href = url.href;
      });
      const rail = section.querySelector('[data-cgg-browse]');
      if (rail) {
        const controls = section.querySelector('[data-cgg-browse-controls]');
        const previous = section.querySelector('[data-cgg-browse-prev]');
        const next = section.querySelector('[data-cgg-browse-next]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const selected = rail.querySelector('[aria-current="page"]');
        if (selected) {
          const selectedLeft = selected.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
          if (selectedLeft + selected.offsetWidth > rail.clientWidth) {
            rail.scrollLeft = Math.max(0, selectedLeft - (rail.clientWidth - selected.offsetWidth) / 2);
          }
        }
        const syncControls = () => {
          const limit = Math.max(0, rail.scrollWidth - rail.clientWidth);
          controls.hidden = limit < 2;
          previous.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft >= limit - 2;
        };
        const move = direction => rail.scrollBy({
          left: direction * Math.max(100, rail.clientWidth * 0.8),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', syncControls, {passive: true});
        // Touch uses native momentum scrolling; mouse users can grab the same strip.
        let drag = null;
        let dragged = false;
        rail.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragged = false;
          drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft};
        });
        rail.addEventListener('pointermove', event => {
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          const dy = event.clientY - drag.y;
          if (!dragged) {
            if (Math.abs(dy) > 6 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
            if (Math.abs(dx) < 6) return;
            dragged = true;
            rail.setPointerCapture(event.pointerId);
            rail.classList.add('is-dragging');
          }
          event.preventDefault();
          rail.scrollLeft = drag.left - dx;
        });
        const endDrag = () => {
          const pointerId = drag?.id;
          drag = null;
          rail.classList.remove('is-dragging');
          if (pointerId !== undefined && rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
        };
        rail.addEventListener('pointerup', endDrag);
        rail.addEventListener('pointercancel', endDrag);
        rail.addEventListener('lostpointercapture', endDrag);
        rail.addEventListener('pointerleave', () => { if (!dragged) drag = null; });
        rail.addEventListener('dragstart', event => event.preventDefault());
        rail.addEventListener('click', event => {
          if (dragged && event.detail !== 0) { event.preventDefault(); event.stopPropagation(); }
        }, true);

        rail.addEventListener('keydown', event => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            rail.scrollTo({left: event.key === 'Home' ? 0 : rail.scrollWidth, behavior: 'auto'});
          }
        });
        const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(syncControls) : null;
        resizeObserver?.observe(rail);
        window.addEventListener('resize', syncControls);
        const cleanup = event => {
          if (!event.target.contains(section)) return;
          resizeObserver?.disconnect();
          window.removeEventListener('resize', syncControls);
          document.removeEventListener('shopify:section:unload', cleanup);
        };
        document.addEventListener('shopify:section:unload', cleanup);
        syncControls();
      }
      const form = section.querySelector('[data-cgg-filter-form]');
      if (!form) return;
      retained.forEach(([key, value]) => {
        if ([...form.elements].some(input => input.name === key)) return;
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = key; input.value = value;
        form.append(input);
      });
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach(input => {
          if (input.value === '') input.disabled = true;
        });
      });
      const sort = section.querySelector('[data-cgg-sort]');
      if (sort) {
        // Size the closed native select to its current label, not the longest option.
        const sizeSort = () => {
          if (!sort.isConnected) return;
          const style = getComputedStyle(sort);
          const measure = document.createElement('span');
          measure.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;';
          measure.style.font = style.font;
          measure.style.letterSpacing = style.letterSpacing;
          measure.textContent = sort.selectedOptions[0]?.textContent || '';
          section.append(measure);
          const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 4;
          sort.style.width = Math.max(100, Math.ceil(measure.getBoundingClientRect().width + padding)) + 'px';
          measure.remove();
        };
        sizeSort();
        document.fonts?.ready.then(sizeSort);
        sort.addEventListener('change', () => { sizeSort(); form.requestSubmit(); });
      }
      section.classList.add('is-enhanced');
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
